import http from "@/utils/http";
/**
 * 素材裁剪
 * **/
export async function crop(data): Promise<any> {
  try {
    const res = await http.post("/api/v1/space/material/crop", data);
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getCropDetail(id) {
  try {
    const res = await http.get(`/api/v1/space/material/crop/${id}`);
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}
